import React, { Component } from 'react'
import { Select } from 'antd';
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { lineData } from '../../dummy/dummy';
const { Option } = Select;
export default class FinanceChart extends Component {

    handleChange = (value) => {
        console.log(`selected ${value}`);
      }

    render() {
        return (
            <div className="finance-chart-wrapper">
                <div className="chart-header">
                    <h2>مؤشر التمويل</h2>
                    <div className="chart-header-action">
                        <div className="left-side">

                            <div className="chart-labels">
                                <p>مؤشر التمويل</p>
                                <p>تمويل شخصي</p>
                            </div>

                            <div className="select-group-wrapper">
                            <Select defaultValue="الفريق" style={{ width: 120, marginLeft : 20 }} onChange={this.handleChange}>
                                    <Option value="الفريق">الفريق</Option>
                                    <Option value="الفريق1">الفريق1</Option>
                                </Select>
                                <Select defaultValue="شهري" style={{ width: 120 }} onChange={this.handleChange}>
                                    <Option value="شهري">شهري</Option>
                                    <Option value="ربعي">ربعي</Option>
                                    <Option value="اسبوعي">اسبوعي</Option>
                                    <Option value="يومي">يومي</Option>
                                </Select>
                            </div>

                        </div>
                        <div className="chart-calender">
                        {/* <DatePicker
                            // selected={this.state.startDate}
                            // onChange={this.handleChange}
                            calendar="hijri"
                            dateFormat="YYYY/MM/DD"
                            dateFormatCalendar="MMMM YYYY"  
                            /> */}
                        </div>
                    </div>
                </div>
                <div style={{ width: '100%', height: 300 }}>
                <ResponsiveContainer width="100%" height="100%">
                <LineChart data={lineData}>
                        <Line type="monotone" dataKey="pv" stroke="#8884d8" activeDot={{ r: 4 }} />
                        <Line type="monotone" dataKey="uv" stroke="#82ca9d" activeDot={{ r: 4 }} /> 
                    <CartesianGrid stroke="#EAEAEA" />
                    <XAxis dataKey="name" /> 
                    <YAxis />
                    <Tooltip />
                </LineChart>
                </ResponsiveContainer>  
                </div>
            </div>
        )
    }
}
